<template>
  <b-overlay
    :show="loading"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <div>
      <b-card title="Fitting result custom fit">
        <b-form @submit.prevent="save">
          <b-row>
            <b-col
              md="6"
              class="mb-1"
            >
              <b-form-group
                label="PDF file"
                label-for="pdf_file"
              >
                <b-form-file
                  id="pdf_file"
                  v-model="pdfUploadFile"
                  :disabled="readOnly"
                  accept=".pdf,application/pdf"
                  placeholder="Choose a PDF file..."
                  drop-placeholder="Drop a PDF file here..."
                  @change="onPdfChange($event)"
                />
                <small
                  v-if="pdfSelectedLabel"
                  class="text-muted d-block mt-50"
                >
                  {{ pdfSelectedLabel }}
                </small>
              </b-form-group>
            </b-col>

            <b-col
              md="6"
              class="mb-1"
            >
              <b-form-group
                label="ZIP/STL file"
                label-for="zip_file"
              >
                <b-form-file
                  id="zip_file"
                  v-model="zippUploadFile"
                  :disabled="readOnly"
                  accept=".zip,.stl,application/zip,application/x-zip-compressed,model/stl,application/sla"
                  placeholder="Choose a ZIP or STL file..."
                  drop-placeholder="Drop a ZIP or STL file here..."
                  @change="onZippChange($event)"
                />
                <small
                  v-if="zippSelectedLabel"
                  class="text-muted d-block mt-50"
                >
                  {{ zippSelectedLabel }}
                </small>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-card>

      <b-button
        v-if="!readOnly"
        variant="primary"
        @click="save"
      >
        {{ isEdition ? 'Update' : 'Create' }}
      </b-button>
    </div>
  </b-overlay>
</template>

<script>
import {
  BOverlay,
  BCard,
  BForm,
  BRow,
  BCol,
  BFormGroup,
  BFormFile,
  BButton,
} from 'bootstrap-vue'
import axios from 'axios'
import { APIRequest } from '@simb2s/senseye-sdk'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'FittingLogCustomFitForm',
  components: {
    BOverlay,
    BCard,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormFile,
    BButton,
  },
  props: {
    fittingResultCustomFit: {
      type: Object,
      default: null,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      isEdition: false,
      currentFittingResultCustomFit: null,
      pdfUploadFile: null,
      zippUploadFile: null,
      pdfSelectedLabel: '',
      zippSelectedLabel: '',
      form: {
        pdf_file: null,
        zip_file: null,
      },
    }
  },
  async mounted() {

    let fitting_results=await APIRequest.list_with_request('fitting-results-custom-fit','?scan='+this.$route.params.id+"&glass="+this.$route.params.glass_id+"&status=success")
    fitting_results=fitting_results[0] || []
    if(fitting_results.length>0)
    {
      this.currentFittingResultCustomFit=fitting_results[0]
    }

    if (!this.currentFittingResultCustomFit && this.fittingResultCustomFit && this.fittingResultCustomFit.id) {
      this.currentFittingResultCustomFit = this.fittingResultCustomFit
    }

    if (this.currentFittingResultCustomFit && this.currentFittingResultCustomFit.id) {
      this.isEdition = true
      this.form.pdf_file = this.currentFittingResultCustomFit.pdf_file || null
      this.form.zip_file = this.currentFittingResultCustomFit.zip_file || this.currentFittingResultCustomFit.image_file || null

      if (this.form.pdf_file) {
        this.pdfSelectedLabel = 'Existing PDF loaded'
      }
      if (this.form.zip_file) {
        this.zippSelectedLabel = 'Existing ZIP/STL loaded'
      }
    }
  },
  methods: {
    showToast(title, variant = 'warning') {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon: variant === 'success' ? 'CheckIcon' : 'AlertCircleIcon',
          variant,
        },
      })
    },
    async onPdfChange(event) {
      const file = event.target.files && event.target.files[0] ? event.target.files[0] : null

      if (!file) {
        return
      }

      const isPdf = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')
      if (!isPdf) {
        this.pdfUploadFile = null
        this.form.pdf_file = null
        this.pdfSelectedLabel = ''
        this.showToast('Please upload a valid PDF file.')
        return
      }

      this.form.pdf_file = file
      this.pdfSelectedLabel = file.name
    },
    async onZippChange(event) {
      const file = event.target.files && event.target.files[0] ? event.target.files[0] : null

      if (!file) {
        return
      }

      const lowerName = file.name ? file.name.toLowerCase() : ''
      const isZip = lowerName.endsWith('.zip')
      const isStl = lowerName.endsWith('.stl')

      if (!isZip && !isStl) {
        this.zippUploadFile = null
        this.form.zip_file = null
        this.zippSelectedLabel = ''
        this.showToast('Please upload a valid ZIP or STL file.')
        return
      }

      this.form.zip_file = file
      this.zippSelectedLabel = file.name
    },
    async save() {
      if (!this.form.pdf_file && !this.form.zip_file) {
        this.showToast('PDF or ZIP/STL file is required.')
        return
      }

     

      this.loading = true
      try {
        const datas = new FormData()
        datas.append('status', 'success')
        datas.append('glass[id]', this.$route.params.glass_id)
        datas.append('scan[id]', this.$route.params.id)

        const hasNewPdfFile = this.form.pdf_file instanceof File
        const hasNewZipFile = this.form.zip_file instanceof File

        if (hasNewPdfFile) {
          datas.append('pdf_file', this.form.pdf_file)
        }
        if (hasNewZipFile) {
          datas.append('zip_file', this.form.zip_file)
        }

        if (!this.isEdition && (!hasNewPdfFile && !hasNewZipFile)) {
          this.showToast('Please select both files before creating.')
          this.loading = false
          return
        }

        const requestConfig = {
          headers: {
            Authorization: `Bearer ${localStorage.token_senseye_auth}`,
          },
          timeout: 10 * 60 * 1000,
          maxContentLength: Infinity,
          maxBodyLength: Infinity,
        }

        const apiUrl = process.env.VUE_APP_API_URL
        let response = null
        if (this.isEdition) {
          datas.append('_method', 'PUT')
          response = await axios.post(
            `${apiUrl}fitting-results-custom-fit/${this.currentFittingResultCustomFit.id}`,
            datas,
            requestConfig,
          )
          this.showToast('Custom fit fitting result updated!', 'success')
        } else {
          response = await axios.post(
            `${apiUrl}fitting-results-custom-fit`,
            datas,
            requestConfig,
          )
          this.showToast('Custom fit fitting result created!', 'success')
        }

        this.$emit('saved', response)
      } catch (error) {
        this.showToast('An error occurred while saving.')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
